import styled from 'styled-components'

import COLORS from 'constants/colors'


export default styled.span`
  color: ${COLORS.ERROR};
  display: block;
  margin-top: 2px;

  &::first-letter {
    text-transform: uppercase;
  }
`
